import React, {useContext} from "react";
import axios from "axios";
import {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import "./fastprint.scss";

import ReactToPrint, {PrintContextConsumer} from "react-to-print";


import ComponentToPrintBarcodeInEditSection from "../Form/ComponentToPrintBarcodeInEditSection";
import {SetPrintDataContext} from "../../Pages";
import {useNavigate} from "react-router-dom";
import Loader from "../Loader";
// const ComponentToPrintBarcodeInEditSection = forwardRef((props, refToPrintBarcode) => {
//     const {submitResponse} = props;
//     console.log(props);
//
//     return (
//         <div ref={refToPrintBarcode}>
//             <BarcodeLabel
//                 barcodeCount={submitResponse !== undefined ? submitResponse.barcodeCount : 1}
//                 barcodeLength={submitResponse !== undefined ? submitResponse.barcodeLength : 33}
//                 barcodeWidth={submitResponse !== undefined ? submitResponse.barcodeWidth : 50}
//                 paperWidth={submitResponse !== undefined ? submitResponse.paperWidth : 55}
//                 productCode={submitResponse !== undefined ? submitResponse.productCode : "1000"}
//                 productColor={submitResponse !== undefined ? submitResponse.productColor : "رنگ"}
//                 productName={submitResponse !== undefined ? submitResponse.productName : "نام محصول"}
//                 productPrice={submitResponse !== undefined ? submitResponse.productPrice : "قیمت"}
//                 productSize={submitResponse !== undefined ? submitResponse.productSize : "سایز"}
//                 productFont={submitResponse !== undefined ? submitResponse.productFont : "14"}
//                 displayProductCodeValue={submitResponse !== undefined ? submitResponse.displayProductCodeValue : true}
//             />
//         </div>
//     )
// });

const FastPrint = () => {
  // const [idToSendBack, setIdToSendBack] = useState(null);
  const setPrint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const [typeToSendBack, setTypeToSendBack] = useState("id");
  const [numberOfBarcodesToPrint, setNumberOfBarcodesToPrint] = useState("");
  const [colorSize, setcolorSize] = useState([]);
  const [KalaSize, setKalaSize] = useState("[]");
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/barcode/`,
      params: {list: "id"},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setSearchDataList(response.data)
      setIsLoad(true)
    })
      .catch((error) => console.error(error));
  }, []);

  function submitAndPrint() {
    // setIdToSendBack(searchIdRef.current.value);
    if (typeToSendBack) {
      if (searchData != "") {
        if (
          numberOfBarcodesToPrint === "" ||
          parseInt(numberOfBarcodesToPrint) <= 0
        ) {
          if (parseInt(numberOfBarcodesToPrint) === 0) {
            toast.error("تعداد بارکد را صحیح وارد کنید.");
          } else {
            toast.error("لطفا تعداد بارکد را وارد کنید.");
          }
          return;
        }
        // const temp = [`${searchData}`]
        // const data={id:temp, type:typeToSendBack}
        //

        // میخوام  تکرار کنم بفرستم بک
        let temp = [];
        let IntNumberOfBarcodesToPrint = +numberOfBarcodesToPrint;
        [...Array(IntNumberOfBarcodesToPrint)].map((v, index) => {
          temp.push(`"${searchData}"`);
        });

        const data = new FormData();
        // data.append('id', '[2812]');
        data.append("id", `[${temp}]`);

        data.append("type", typeToSendBack);
        data.append("options", KalaSize);
        data.append("request", "barcodeData");
        //
        const factorSubmitRequest = axios({
          method: "post",
          url: `${localStorage.getItem("apiUrl")}/barcode/`,
          // params: {id: temp, type: typeToSendBack},
          data: data,
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then((response) => {
          if (response.data.status) {
            response.data.type = "BarcodeDataPrint";
            const sendData = {
              type: response.data.type, data: response.data,
            };
            setPrint(sendData);
            navigate("/factorprint");
          } else {
            toast.error(response?.data?.message)
          }
        });

        toast.promise(factorSubmitRequest, {
          pending: "در حال دریافت بارکد ",
          success: "بارکد با موفقیت دریافت شد.",
          error: "دریافت بارکد  با مشکل مواجه شد",
        });
      } else {
        toast.error(" لطفا کد کالا رو وارد کنید!");
      }
    } else {
      toast.error("بر اساس کد کالا یا فروشگاه؟");
    }
  }

  const [submitResponse, setSubmitResponse] = useState(undefined);
  // useEffect(() => {
  // }, [submitResponse])

  const [searchData, setSearchData] = useState("");
  const [searchDataList, setSearchDataList] = useState([]);

  function searchParamOnChangeHandlerPrintFunction(e) {
    setTypeToSendBack(e.target.value);
    setSearchData("");
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/barcode/`,
      params: {list: e.target.value},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => setSearchDataList(response.data))
      .catch((error) => console.error(error));
  }

  const searchbarcodeHandler = (e) => {
    if (typeToSendBack === "name") {
      setSearchData(e.target.value);
      axios({
        method: "GET",
        url: `${localStorage.getItem("apiUrl")}/barcode/?sizeAndColor=${
          e.target.value
        }`,
        headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      }).then((response) => setcolorSize(response.data));
    } else setSearchData(e.target.value);
  };
  const refToPrintBarcode = useRef();
  // const height= submitResponse !== undefined ? '150px' : '300px';
  const heightStyle = `
 .plzSetCorrectHeight{
    height: ${
    submitResponse === undefined
      ? "auto"
      : submitResponse.barcodeLength + 4 + "mm"
  };
    display: flex;
    justify-content: space-around;
    flex-flow: column;
    margin: 0 auto;
    width: 100%;
    
    }
 `;
  const colorSizeClasses =
    typeToSendBack === "name" ? "divgroup" : "divgroup hiddendiv";

  try {
    return (
      <>
        <style> {heightStyle}</style>
        {isLoad ?
          <div className={"inDashboardCssFastPrint  d-flex  justify-content-around"}>
            <div className="search-object text-center" style={{width: "90%"}}>
              <div className={"plzSetCorrectHeight"}>
                <div className="d-flex justify-content-between w-100">
                  {" "}
                  <div className="form-control0">
                    <input
                      value={"name"}
                      className="form-check-input"
                      type="radio"
                      name={"rnd1"}
                      id={"rnd1"}
                      onChange={searchParamOnChangeHandlerPrintFunction}
                    />
                    <label className="form-check-label" htmlFor={"rnd1"}>
                      نام کالا
                    </label>
                  </div>
                  <div className="form-control0">
                    <input
                      value={"internetId"}
                      className="form-check-input"
                      type="radio"
                      name={"rnd1"}
                      id={"rnd2"}
                      onChange={searchParamOnChangeHandlerPrintFunction}
                    />
                    <label className="form-check-label" htmlFor={"rnd2"}>
                      کد کالای اینترنتی
                    </label>
                  </div>
                  <div className="form-control0">
                    <input
                      value={"id"}
                      className="form-check-input"
                      type="radio"
                      name={"rnd1"}
                      id={"rnd3"}
                      defaultChecked
                      onChange={searchParamOnChangeHandlerPrintFunction}
                    />
                    <label className="form-check-label" htmlFor={"rnd3"}>
                      بارکد
                    </label>
                  </div>
                </div>

                <div>
                  <div className="divgroup">
                    <label className="form-check-label" htmlFor={"rnd1"}>
                      جستجو
                    </label>
                    <input
                      type="search"
                      className="form-control newinput"
                      name="search"
                      list="factorPageProductList"
                      autoComplete="off"
                      value={searchData}
                      onChange={searchbarcodeHandler}
                    />
                    <datalist defaultValue={""} id="factorPageProductList">
                      <option value={""}/>
                      {searchDataList?.map((value, index) => (
                        <React.Fragment key={index}>
                          <option value={value}/>
                        </React.Fragment>
                      ))}
                    </datalist>
                  </div>
                </div>
                <div className="dis-flex">
                  <div className="divgroup">
                    <label className="form-check-label" htmlFor={"rnd1"}>
                      تعداد بارکد
                    </label>
                    <input
                      type="number"
                      className="form-control mb-3"
                      onChange={(event) => {
                        let temp = event.target.value;
                        if (temp < 0) {
                          temp = 0;
                        }
                        setNumberOfBarcodesToPrint(temp);
                      }}
                      value={numberOfBarcodesToPrint}
                    />
                  </div>
                  <div className={colorSizeClasses}>
                    <label className="form-check-label" htmlFor={"rnd1"}>
                      رنگ و سایز
                    </label>
                    <select
                      onChange={(e) => setKalaSize(e.target.value)}
                      defaultValue={"nullSelect"}
                      className="form-select form-select mb-3"
                      aria-label=".form-select-lg example"
                    >
                      <option selected hidden>
                        رنگ و سایز را انتخاب کنید
                      </option>
                      {colorSize.map((value) => (
                        <option value={value.color + "---" + value.size}>
                          {value.color + " " + value.size}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* <datalist defaultValue={""} id="factorPageProductList">
              <option value={""} />
              {searchDataList.map((value, index) => (
                <React.Fragment key={index}>
                  <option value={value} />
                </React.Fragment>
              ))}
            </datalist>
        */}
              </div>

              <div className="text-center">
                <button className="btnCustom btnSubmit" onClick={submitAndPrint}>
                  پرینت بارکد
                </button>
              </div>
            </div>
            <div className={submitResponse === undefined ? "d-none" : "d-block"}>
              <div
                className={"border border-dark rounded-3"}
                style={{
                  margin: " 0 auto",
                  width: "max-content",
                  maxHeight: "22mm",
                  maxWidth:
                    submitResponse !== undefined
                      ? `${submitResponse[0].barcodeWidth}mm`
                      : "0",
                  overflow: "hidden",
                }}
              >
                <ComponentToPrintBarcodeInEditSection
                  submitResponse={submitResponse}
                  ref={refToPrintBarcode}
                />
              </div>
              <br/>
              <div className={"text-center"}>
                <ReactToPrint content={() => refToPrintBarcode.current}>
                  <PrintContextConsumer>
                    {({handlePrint}) => (
                      <button
                        disabled={submitResponse === undefined}
                        className="btnCustom btnSubmit"
                        onClick={handlePrint}
                      >
                        پرینت بارکد
                      </button>
                    )}
                  </PrintContextConsumer>
                </ReactToPrint>
              </div>
            </div>
          </div> : <div style={{height:'300px'}}></div>}
      </>
    );
  } catch (error) {
    return <>{error.toString()}</>
  }
};

export default FastPrint;
